import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Navbar.css';
import { FaBars, FaTimes, FaGlobe } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage, languages } from '../context/LanguageContext';
import { translations } from '../translations/translations';
import Logo from '../assets/JK_LOGO.png';

function Navbar() {
    const [expandNavbar, setExpandNavbar] = useState(false);
    const [showLangMenu, setShowLangMenu] = useState(false);
    const location = useLocation();
    const { language, setLanguage } = useLanguage();
    const t = translations[language];

    useEffect(() => {
        setExpandNavbar(false);
        setShowLangMenu(false);
    }, [location]);

    const handleLanguageChange = (lang) => {
        setLanguage(lang);
        setShowLangMenu(false);
    };

    return (
        <div className="navbar-container">
            <div className="navbar">
                <div className="logo">
                    <Link to="/"><img src={Logo} alt="JK Logo" /></Link>
                </div>
                <div className="links desktop">
                    <Link to="/"> {t.nav.home} </Link>
                    <Link to="/projects"> {t.nav.projects} </Link>
                    <Link to="/skills"> {t.nav.skills} </Link>
                    <Link to="/experience"> {t.nav.experience} </Link>
                    <div className="language-selector">
                        <button 
                            className="lang-btn"
                            onClick={() => setShowLangMenu(!showLangMenu)}
                        >
                            <FaGlobe /> {languages[language]}
                        </button>
                        {showLangMenu && (
                            <div className="lang-dropdown">
                                {Object.entries(languages).map(([code, name]) => (
                                    <button
                                        key={code}
                                        className={`lang-option ${language === code ? 'active' : ''}`}
                                        onClick={() => handleLanguageChange(code)}
                                    >
                                        {name}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <div className="toggleButton">
                    <button onClick={() => setExpandNavbar((prev) => !prev)}>
                        {expandNavbar ? <FaTimes /> : <FaBars />}
                    </button>
                </div>
            </div>

            <AnimatePresence>
                {expandNavbar && (
                    <motion.div
                        className="mobile-menu glass"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                    >
                        <Link to="/"> {t.nav.home} </Link>
                        <Link to="/projects"> {t.nav.projects} </Link>
                        <Link to="/skills"> {t.nav.skills} </Link>
                        <Link to="/experience"> {t.nav.experience} </Link>
                        <div className="mobile-language-selector">
                            {Object.entries(languages).map(([code, name]) => (
                                <button
                                    key={code}
                                    className={`mobile-lang-btn ${language === code ? 'active' : ''}`}
                                    onClick={() => handleLanguageChange(code)}
                                >
                                    {name}
                                </button>
                            ))}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}

export default Navbar;